/* @flow */

import { type Address } from './types';
import { type Pedido } from '../pedidos/types';
import converterEnderecoEmAddress from './converterEnderecoEmAddress';
import isRetiradaNoLocal from '../enderecos/is-retirada-no-local';

const getAddressDoPedido = ({ endereco }: Pedido): ?Address => {
    if (!endereco || isRetiradaNoLocal(endereco)) {
        return null;
    }

    return converterEnderecoEmAddress(endereco);
};

export default getAddressDoPedido;
